<div class="api-card">
  <div class="api-card__header">
    <div class="api-card__header-stack">
      <span class="api-card__title">Users</span>
      <span class="api-card__desc">All users across the platform.</span>
    </div>
  </div>


  <div class="admin-table-scroll">
    <table class="billing-table admin-stack admin-stack--users-preview">
      <thead>
        <tr>
          <th>User</th>
          <th>Organization</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        @if (isLoading) {
          @for (i of [1,2,3,4]; track i) {
            <tr>
              <td><app-skeleton width="70%" height="14px"></app-skeleton></td>
              <td><app-skeleton width="60%" height="14px"></app-skeleton></td>
              <td><app-skeleton width="60px" height="20px" radius="4px"></app-skeleton></td>
            </tr>
          }
        } @else {
          @for (row of rows; track row.id) {
            <tr>
              <td>{{ row.name }}<br><span class="billing-table__sub">{{ row.email }}</span></td>
              <td>{{ row.superadmin ? 'Platform staff' : primaryOrg(row) }}</td>
              <td>
                @if (row.confirmed) {
                  Confirmed
                } @else {
                  <span class="txn-kind-badge txn-kind-badge--warning">Pending</span>
                }
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>

  <div class="api-card__footer">
    <a routerLink="/admin/users" class="link">
      View all users
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M4.5 2.5L8 6L4.5 9.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </a>
  </div>
</div>
